export default __webpack_public_path__ + "static/media/music_off.100b346f.svg";